import { useUpdateProposalProductDiscountMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateProposalProductDiscount() {
  const [mutation, { loading, data, error }] = useUpdateProposalProductDiscountMutation({
    refetchQueries: ["getProposal", "customGetProposal"],
    awaitRefetchQueries: true,
  });
  const [updateProposalProductDiscount, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateProposalProductDiscount",
    },
    {
      hideMessage: true,
    }
  );

  return [updateProposalProductDiscount, context] as const;
}
